import React from "react";
import { Link } from "react-router-dom";

export default function TermsAndConditions() {
  return (
    <div className="min-h-screen bg-white text-slate-900">
      <div className="mx-auto max-w-3xl px-4 py-12 space-y-6">
        <h1 className="text-2xl sm:text-3xl font-semibold tracking-tight">
          Terms &amp; Conditions (SMS)
        </h1>

        <p className="text-sm text-slate-700">
          By providing your phone number and opting in, you agree to receive SMS
          text messages from <span className="font-semibold">Your Property Guys</span>.
        </p>

        <div className="space-y-3 text-sm text-slate-700">
          <p>
            <span className="font-semibold">Message types:</span> Appointment scheduling,
            project updates, estimate follow-ups, and customer support.
          </p>
          <p>
            <span className="font-semibold">Message frequency:</span> Message frequency varies.
          </p>
          <p>
            <span className="font-semibold">Message &amp; data rates:</span> Message and data rates may apply.
          </p>
          <p>
            <span className="font-semibold">Opt-out:</span> Reply <span className="font-semibold">STOP</span> to unsubscribe.
          </p>
          <p>
            <span className="font-semibold">Help:</span> Reply <span className="font-semibold">HELP</span> for assistance.
          </p>
          <p>
            <span className="font-semibold">Consent not required:</span> Consent to receive texts is not a condition
            of purchase.
          </p>
        </div>

        <div className="pt-2 text-sm">
          <Link to="/privacypolicy" className="text-ypgGreen hover:underline">
            Privacy Policy
          </Link>{" "}
          <span className="text-slate-400">·</span>{" "}
          <Link to="/" className="text-ypgGreen hover:underline">
            Home
          </Link>
        </div>
      </div>
    </div>
  );
}